import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=35a6b6de"
import script from "./Playlist.vue?vue&type=script&lang=ts"
export * from "./Playlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports